import { useState } from 'react'
import { Card, Table, Tag, Input, Select, DatePicker, Button, Space } from 'antd'
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons'

const { RangePicker } = DatePicker
const { Option } = Select

const OperationLogs = () => {
  const [searchText, setSearchText] = useState('')

  const columns = [
    {
      title: '时间',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 180,
    },
    {
      title: '用户',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: '操作类型',
      dataIndex: 'operationType',
      key: 'operationType',
      render: (type: string) => {
        const colors: Record<string, string> = {
          create: 'green',
          update: 'blue',
          delete: 'red',
          query: 'default',
          export: 'purple',
        }
        return <Tag color={colors[type] || 'default'}>{type}</Tag>
      },
    },
    {
      title: '操作对象',
      dataIndex: 'targetType',
      key: 'targetType',
    },
    {
      title: '对象ID',
      dataIndex: 'targetId',
      key: 'targetId',
      render: (text: string) => <code className="text-xs">{text}</code>,
    },
    {
      title: '详情',
      dataIndex: 'details',
      key: 'details',
      ellipsis: true,
    },
    {
      title: '结果',
      dataIndex: 'result',
      key: 'result',
      render: (result: string) => (
        <Tag color={result === 'success' ? 'success' : 'error'}>
          {result === 'success' ? '✓ 成功' : '✗ 失败'}
        </Tag>
      ),
    },
    {
      title: 'IP地址',
      dataIndex: 'ipAddress',
      key: 'ipAddress',
      render: (text: string) => <span className="text-xs font-mono">{text}</span>,
    },
  ]

  const mockLogs = [
    {
      id: '1',
      timestamp: '2026-02-22 15:30:25',
      username: 'annotator1',
      operationType: 'update',
      targetType: 'annotation',
      targetId: 'CASE-2024-0001',
      details: '提交标注结果',
      result: 'success',
      ipAddress: '192.168.1.100',
    },
    {
      id: '2',
      timestamp: '2026-02-22 15:28:10',
      username: 'reviewer1',
      operationType: 'update',
      targetType: 'annotation',
      targetId: 'CASE-2024-0001',
      details: '审核通过',
      result: 'success',
      ipAddress: '192.168.1.101',
    },
    {
      id: '3',
      timestamp: '2026-02-22 15:25:33',
      username: 'query1',
      operationType: 'query',
      targetType: 'case',
      targetId: 'multiple',
      details: '多条件筛选查询',
      result: 'success',
      ipAddress: '192.168.1.102',
    },
    {
      id: '4',
      timestamp: '2026-02-22 15:20:15',
      username: 'admin',
      operationType: 'update',
      targetType: 'system',
      targetId: 'config',
      details: '修改系统设置：清洗配置',
      result: 'success',
      ipAddress: '192.168.1.1',
    },
    {
      id: '5',
      timestamp: '2026-02-22 15:15:42',
      username: 'annotator1',
      operationType: 'create',
      targetType: 'session',
      targetId: 'login',
      details: '用户登录',
      result: 'success',
      ipAddress: '192.168.1.100',
    },
  ]

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">📋 操作日志</h1>
        <Button icon={<DownloadOutlined />}>导出日志</Button>
      </div>

      <Card>
        <div className="flex gap-4 mb-4">
          <Input
            prefix={<SearchOutlined />}
            placeholder="搜索..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 250 }}
          />
          <Select placeholder="用户筛选" style={{ width: 150 }}>
            <Option value="admin">admin</Option>
            <Option value="annotator1">annotator1</Option>
            <Option value="reviewer1">reviewer1</Option>
          </Select>
          <RangePicker />
          <Select placeholder="操作类型" style={{ width: 150 }}>
            <Option value="create">创建</Option>
            <Option value="update">更新</Option>
            <Option value="delete">删除</Option>
            <Option value="query">查询</Option>
          </Select>
          <Button type="primary">查询</Button>
        </div>

        <Table
          columns={columns}
          dataSource={mockLogs}
          rowKey="id"
          pagination={{ pageSize: 20 }}
        />
      </Card>
    </div>
  )
}

export default OperationLogs
